import { IBlockInstanceModel } from 'models/block.model'
import { BlockTypes } from 'enum/block-type.enum'
import api from '../..'

export interface LessonBlocksListResult {
  blocks: IBlockInstanceModel[]
  aiEvaluationQuestionsEnabled: boolean
  meetingsEnabled: boolean
}

const lessonBlocksList = (
  lessonId: number
): Promise<LessonBlocksListResult> => {
  return api
    .get(`administration/lessons/${lessonId}/block_instances`)
    .then<LessonBlocksListResult>(({ data }) => {
      const aiEvaluationQuestionsEnabled =
        data.meta?.aiEvaluationQuestionsEnabled ?? false
      const meetingsEnabled = data.meta?.meetingsEnabled ?? false

      const blocks = data.data.map(
        ({ attributes }: any): IBlockInstanceModel => {
          let file = undefined
          let evaluationConfig = undefined

          if (attributes.blockInstanceable.fileData)
            file = {
              ...attributes.blockInstanceable.fileData,
              url: attributes.url,
            }
          if (attributes.blockInstanceableType === BlockTypes.BlockEvaluation)
            evaluationConfig = attributes.blockInstanceable

          const {
            id,
            name,
            description,
            mandatory,
            blockInstanceableType,
            blockInstanceableId,
            blockInstanceable,
            order,
            containFiles,
            hasResponses,
          } = attributes

          return {
            id,
            name,
            description,
            mandatory,
            blockType: blockInstanceableType,
            blockId: blockInstanceableId,
            content: blockInstanceable.content || '',
            multiFile: blockInstanceable.multipleFileUpload || false,
            allowPublic: blockInstanceable.allowPublic || false,
            processed: blockInstanceable.processed || false,
            processing: blockInstanceable.processing || false,
            loadPercentage: blockInstanceable.loadPercentage || 0,
            openNewWindow: blockInstanceable.openNewWindow || false,
            blockInstanceableId,
            blockInstanceable,
            isValidated: blockInstanceable.isValidated,
            order,
            file: file || undefined,
            showTitle: blockInstanceable.showTitle || false,
            lockProgress: blockInstanceable.lockProgress || false,
            denyDownload: blockInstanceable.denyDownload || false,
            evaluationConfig,
            containFiles: containFiles || false,
            hasResponses: hasResponses || false,
            blockAdvance: blockInstanceable.blockAdvance || false,
          }
        }
      )

      return { blocks, aiEvaluationQuestionsEnabled, meetingsEnabled }
    })
}
export default lessonBlocksList
